<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Performance Inputs</label>
  <span class="spacer"></span>
  @if (canExpand) {
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  }
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="inputRow">
      <span class="inputWrapper">
        <label class="configurationInputLabel">Fan Speed:</label>
        <select class="configurationInputField" [(ngModel)]="request.fanSpeed" #fanSpeedInput
          (change)="localInputChanged('USFSpeed', fanSpeedInput.value)">
          <option [value]="'H'">High</option>
          <option [value]="'M'">Medium</option>
          <option [value]="'L'">Low</option>
          <option [value]="'C'">ECM Design Airflow</option>
        </select>
      </span>
      <span class="inputWrapper">
        <label class="configurationInputLabel">Airflow:</label>
        <input type="number" class="configurationRatingTextInput" [(ngModel)]="request.airflow" #airflowInput
          (change)="localInputChanged('USFAirflow', airflowInput.value)"/>
        <label class="configurationRatingUnitLabel">{{ getAirflowUnits() }}</label>
      </span>
      <span class="inputWrapper">
        <label class="configurationInputLabel">ESP:</label>
        <input type="number" class="configurationRatingTextInput" [(ngModel)]="request.externalStaticPressure" #espInput
          (change)="localInputChanged('USFESP', espInput.value)"/>
        <label class="configurationRatingUnitLabel">{{ getEspUnits() }}</label>
      </span>
      <span class="inputWrapper">
        <label class="configurationInputLabel">Altitude:</label>
        <input type="number" class="configurationRatingTextInput" [(ngModel)]="request.altitude" #altitudeInput
          (change)="localInputChanged('USAltitude', altitudeInput.value)"/>
        <label class="configurationRatingUnitLabel">{{ getLengthUnits() }}</label>
      </span>
    </div>
    <div class="inputRow">
      @if (request.primaryCoilRequest) {
        <div class="coilRatingContainer">
          <app-performance-coil-inputs-section [coilRequest]="request.primaryCoilRequest" [unitData]="unitData()"
            (targetChanged)="targetLoadChanged()"
            (inputChanged)="inputChanged($event)"
            [fieldLabel]="request.primaryCoilRequest.isCooling ? 'Cooling Conditions' : 'Heating Conditions'"
            [metricInput]="request.metric">
          </app-performance-coil-inputs-section>
        </div>
      }
      @if (request.secondaryCoilRequest) {
        <div class="coilRatingContainer">
          <app-performance-coil-inputs-section [coilRequest]="request.secondaryCoilRequest" [unitData]="unitData()"
            (targetChanged)="targetLoadChanged()"
            (inputChanged)="inputChanged($event)" [fieldLabel]="'Heating Conditions'"
            [metricInput]="request.metric">
          </app-performance-coil-inputs-section>
        </div>
      }
      @if (request.electricHeatRequest) {
        <div class="coilRatingContainer">
          <app-performance-coil-inputs-section [coilRequest]="request.electricHeatRequest"
            (targetChanged)="targetLoadChanged()"
            (inputChanged)="inputChanged($event)" [fieldLabel]="'Electric Heat'"
            [metricInput]="request.metric">
          </app-performance-coil-inputs-section>
        </div>
      }
    </div>
  </div>
}

